// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3LUe0","checkboxCol":"Table_checkboxCol__3iazl","emailCol":"Table_emailCol__2vr2a","actionCol":"Table_actionCol__323WH"};